import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { createGuessAvatarRoom, getGuessAvatarRoom } from './guessAvatarService';
import './GuessAvatarEntryPage.css';

function GuessAvatarEntryPage() {
  const navigate = useNavigate();
  const [roomIdInput, setRoomIdInput] = useState('');
  const [isCreating, setIsCreating] = useState(false);
  const [isJoining, setIsJoining] = useState(false);
  const [error, setError] = useState(null);

  const handleCreateRoom = async () => {
    setError(null);
    setIsCreating(true);

    try {
      const roomId = await createGuessAvatarRoom('猜头像游戏', '猜猜哪个是你的头像');
      navigate(`/guess-avatar/room/${roomId}`);
    } catch (err) {
      console.error('Failed to create room:', err);
      setError(err.message || '创建房间失败，请稍后重试');
    } finally {
      setIsCreating(false);
    }
  };

  const handleJoinRoom = async () => {
    if (!roomIdInput.trim()) {
      setError('请输入房间号');
      return;
    }

    const roomId = parseInt(roomIdInput, 10);
    if (isNaN(roomId) || roomId <= 0) {
      setError('请输入有效的房间号');
      return;
    }

    setError(null);
    setIsJoining(true);

    try {
      const roomData = await getGuessAvatarRoom(roomId);
      navigate(`/guess-avatar/room/${roomId}`, {
        state: {
          initialData: roomData,
          mode: 'result'
        }
      });
    } catch (err) {
      console.error('Failed to join room:', err);
      if (err.message.includes('404') || err.message.includes('not found')) {
        setError('房间不存在，请检查房间号');
      } else {
        setError(err.message || '加入房间失败，请稍后重试');
      }
    } finally {
      setIsJoining(false);
    }
  };

  const handleInputChange = (e) => {
    setRoomIdInput(e.target.value);
    if (error) setError(null);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && roomIdInput.trim()) {
      handleJoinRoom();
    }
  };

  return (
    <div className="guess-avatar-entry-container">
      <header className="entry-header">
        <h1 className="entry-title">
          <span className="title-gradient">猜头像游戏</span>
        </h1>
        <p className="entry-description">
          创建房间生成头像，或加入已有房间进行游戏
        </p>
      </header>

      {error && (
        <div className="error-banner">
          <span className="error-icon">⚠️</span>
          <span className="error-message">{error}</span>
          <button className="error-close" onClick={() => setError(null)}>
            ×
          </button>
        </div>
      )}

      <div className="entry-actions">
        <button
          className="btn-create-room"
          onClick={handleCreateRoom}
          disabled={isCreating || isJoining}
        >
          {isCreating ? '创建中...' : '🎮 创建房间'}
        </button>

        <div className="divider">
          <span>或者</span>
        </div>

        <div className="join-room-section">
          <input
            type="text"
            className="room-id-input"
            placeholder="输入房间号"
            value={roomIdInput}
            onChange={handleInputChange}
            onKeyPress={handleKeyPress}
            disabled={isCreating || isJoining}
          />
          <button
            className="btn-join-room"
            onClick={handleJoinRoom}
            disabled={!roomIdInput.trim() || isCreating || isJoining}
          >
            {isJoining ? '加入中...' : '🚪 加入房间'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default GuessAvatarEntryPage;
